// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { PaginationMeta, PaginationMetaT, verifyPaginationMeta } from "./pagination-meta";
import { Adapter, AdapterT, verifyAdapter } from "../archive/adapter";

/**
 * Paginated response for adapters.
 */
export class PaginatedAdapters implements flatbuffers.IUnpackableObject<PaginatedAdaptersT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): PaginatedAdapters {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsPaginatedAdapters(
    bb: flatbuffers.ByteBuffer,
    obj?: PaginatedAdapters,
  ): PaginatedAdapters {
    return (obj || new PaginatedAdapters()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsPaginatedAdapters(
    bb: flatbuffers.ByteBuffer,
    obj?: PaginatedAdapters,
  ): PaginatedAdapters {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new PaginatedAdapters()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  meta(obj?: PaginationMeta): PaginationMeta | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new PaginationMeta()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  data(index: number, obj?: Adapter): Adapter | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Adapter()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  dataLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startPaginatedAdapters(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMeta(builder: flatbuffers.Builder, metaOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, metaOffset, 0);
  }

  static addData(builder: flatbuffers.Builder, dataOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, dataOffset, 0);
  }

  static createDataVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startDataVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endPaginatedAdapters(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createPaginatedAdapters(
    builder: flatbuffers.Builder,
    metaOffset: flatbuffers.Offset,
    dataOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    PaginatedAdapters.startPaginatedAdapters(builder);
    PaginatedAdapters.addMeta(builder, metaOffset);
    PaginatedAdapters.addData(builder, dataOffset);
    return PaginatedAdapters.endPaginatedAdapters(builder);
  }

  unpack(): PaginatedAdaptersT {
    return new PaginatedAdaptersT(
      this.meta() !== null ? this.meta()!.unpack() : null,
      this.bb!.createObjList<Adapter, AdapterT>(this.data.bind(this), this.dataLength()),
    );
  }

  unpackTo(_o: PaginatedAdaptersT): void {
    _o.meta = this.meta() !== null ? this.meta()!.unpack() : null;
    _o.data = this.bb!.createObjList<Adapter, AdapterT>(this.data.bind(this), this.dataLength());
  }

  unpackFields(...fields: string[]): PaginatedAdaptersT {
    const t = new PaginatedAdaptersT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("meta")) {
      t.meta = this.meta() !== null ? this.meta()!.unpack() : null;
    }
    if (fieldSet.has("data")) {
      t.data = this.bb!.createObjList<Adapter, AdapterT>(this.data.bind(this), this.dataLength());
    }
    return t;
  }
}

export class PaginatedAdaptersT implements flatbuffers.IGeneratedObject {
  constructor(
    public meta: PaginationMetaT | null = null,
    public data: AdapterT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const meta = this.meta !== null ? this.meta!.pack(builder) : 0;
    const data = PaginatedAdapters.createDataVector(
      builder,
      builder.createObjectOffsetList(this.data),
    );

    return PaginatedAdapters.createPaginatedAdapters(builder, meta, data);
  }

  clone(): PaginatedAdaptersT {
    const obj = new PaginatedAdaptersT();
    obj.meta = this.meta !== null ? this.meta!.clone() : null;
    obj.data = this.data.map((e) => e.clone());
    return obj;
  }

  equals(other: PaginatedAdaptersT): boolean {
    if (this.meta !== null && other.meta !== null) {
      if (!this.meta!.equals(other.meta!)) return false;
    } else if (this.meta !== other.meta) return false;
    if (this.data.length !== other.data.length) return false;
    for (let i = 0; i < this.data.length; i++) {
      const a = this.data[i];
      const b = other.data[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyPaginatedAdapters(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyPaginationMeta(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyAdapter);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
